import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["text", "appearance", "tip", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { PromoTag } from '@snack-uikit/promo-tag';
import { Tooltip } from '../../helperComponents';
import { jsx as _jsx } from "react/jsx-runtime";
export function TagSpecial(_ref) {
  var text = _ref.text,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance,
    tip = _ref.tip,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(PromoTag, _objectSpread({
    size: "xs",
    text: text,
    appearance: appearance,
    color: "decor",
    afterContent: tip && /*#__PURE__*/_jsx(Tooltip, {
      appearance: appearance,
      tip: tip
    }),
    className: className
  }, extractSupportProps(rest)));
}